import { InlineNodeModel } from "@/models/nodes/InlineNodeModel";
import { WrapperNodeModel } from "@/models/nodes/WrapperNodeModel";
import { afterDelayedFocus } from "@/utils/afterDelayedFocus";

import type { DocumentModel } from "@/models/DocumentModel";

export function splitInlineExpressionAndCreateTextBlock(doc: DocumentModel) {
  const { node, index } = doc.cursor;
  const { tiptap } = doc.editor;
  if (!tiptap || !node) return;

  const currentAnchor = tiptap.state.selection.anchor || 0;
  const initialParentTiptapNodePosition = doc.cursor.parentTiptapNode.position;

  let newInlineNode: InlineNodeModel;

  doc.transact(() => {
    if (doc.cursor.nodeAfterCursor) {
      if (doc.cursor.nodeBeforeCursor && node.parent?.is(WrapperNodeModel)) {
        doc.computedNodes.setComputed(node.parent, false);
      }
      newInlineNode = doc.create(InlineNodeModel);
      newInlineNode.appendChildren(node.nodes.slice(index));

      tiptap
        .chain()
        .focus(currentAnchor + 1)
        .splitBlockOrListItem()
        .insertInlineExpression(newInlineNode)
        .run();

      afterDelayedFocus(() => {
        doc.cursor.moveTo(newInlineNode, 0);
      });

      if (node.nodes.length === 0) {
        tiptap.commands.deleteRange({
          from: initialParentTiptapNodePosition,
          to: initialParentTiptapNodePosition + 1,
        });
      }
    } else {
      tiptap
        .chain()
        .focus(currentAnchor + 1)
        .splitBlockOrListItem()
        .run();
    }
  }, "splitInlineExpressionAndCreateTextBlock");
}
